'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RadioButton = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var RadioButton = function RadioButton(_ref) {
  var label = _ref.label,
      checked = _ref.checked,
      name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      validate = _ref.validate,
      className = _ref.className,
      props = (0, _objectWithoutProperties3.default)(_ref, ['label', 'checked', 'name', 'value', 'onChange', 'validate', 'className']);

  return _react2.default.createElement('label', (0, _extends3.default)({
    className: (0, _classnames2.default)(className, 'frm-Form_RadioButton', {
      'frm-Form-validate': validate
    })
  }, props), _react2.default.createElement('input', { type: 'radio', value: value, checked: checked, onChange: onChange, name: name }), _react2.default.createElement('span', { className: 'frm-Form_RadioButtonIcon' }), label && _react2.default.createElement('p', { className: 'frm-Form_Label' }, label));
};

RadioButton.defaultProps = {
  label: undefined,
  checked: false,
  name: undefined,
  validate: false,
  className: undefined
};

RadioButton.propTypes = {
  label: _propTypes2.default.string,
  checked: _propTypes2.default.bool.isRequired,
  name: _propTypes2.default.string,
  validate: _propTypes2.default.bool,
  value: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string
};

exports.RadioButton = RadioButton;